// Year-on-year trends across Lenovo India CSR's 4 focus areas

export const YOY_BENEFICIARIES = [
  { fy: "FY 21-22", stem: 3000, digital: 1800, employability: 1500, sustainability: 600 },
  { fy: "FY 22-23", stem: 5200, digital: 3200, employability: 2400, sustainability: 1100 },
  { fy: "FY 23-24", stem: 8400, digital: 5600, employability: 3900, sustainability: 1800 },
  { fy: "FY 24-25", stem: 12000, digital: 9000, employability: 6000, sustainability: 3200 },
];

// Sanctioned amount (₹ Cr) per pillar per FY — totals align with YOY_SPEND_CR
export const YOY_SANCTIONED_CR = [
  { fy: "FY 21-22", stem: 4.0, digital: 2.6, employability: 2.2, sustainability: 1.4 },
  { fy: "FY 22-23", stem: 5.5, digital: 3.6, employability: 3.0, sustainability: 2.0 },
  { fy: "FY 23-24", stem: 6.8, digital: 4.6, employability: 3.8, sustainability: 2.6 },
  { fy: "FY 24-25", stem: 8.2, digital: 5.8, employability: 4.6, sustainability: 3.2 },
];

// % of sanctioned that has been disbursed / utilised (older FYs trend higher;
// current FY is still in-flight so utilisation lags).
export const SANCTIONED_BREAKDOWN_RATIOS = {
  "FY 21-22": { disb: 0.96, util: 0.91 },
  "FY 22-23": { disb: 0.93, util: 0.85 },
  "FY 23-24": { disb: 0.88, util: 0.74 },
  "FY 24-25": { disb: 0.72, util: 0.55 },
};

export const YOY_SPEND_CR = [
  { fy: "FY 21-22", spend: 10.2, target: 11 },
  { fy: "FY 22-23", spend: 14.1, target: 14 },
  { fy: "FY 23-24", spend: 17.8, target: 18 },
  { fy: "FY 24-25", spend: 21.8, target: 22 },
];

export const YOY_TREES = [
  { fy: "FY 21-22", trees: 20000 },
  { fy: "FY 22-23", trees: 60000 },
  { fy: "FY 23-24", trees: 120000 },
  { fy: "FY 24-25", trees: 240000 },
];
